/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import jApiFormUi from '@/services/jApiFormUi';

const state = {
  setup_form_ui: [],
  setup_multi_form_ui: [],
  changed_tab: false,
  data_record: null,
  changes_value_view: false,

  // FORM UI
  form_detail: [],
  list_form_ui: [],

  // MULTIPLE FORM UI
  multiple_form_detail: [],
  list_multiple_form_ui: [],

  // FORM DATA
  list_form_data: [],
  form_data_detail: [],
};

const mutations = {
  setSetupFormUi(state, payload) {
    state.setup_form_ui = payload;
  },

  setSetupMultiFormUi(state, payload) {
    state.setup_multi_form_ui = payload;
  },

  setDataRecord(state, payload) {
    state.data_record = payload;
  },

  // FORM UI
  setFormDetail(state, data) {
    state.form_detail = data;
  },

  setFormUiList(state, data) {
    state.list_form_ui = data;
  },

  // MULTIPLE FORM UI
  setMultiFormDetail(state, data) {
    state.multiple_form_detail = data;
  },

  setMultiFormUiList(state, data) {
    state.list_multiple_form_ui = data;
  },

  // FORM DATA
  setFormDataList(state, data) {
    state.list_form_data = data;
  },

  setFormDataDetail(state, data) {
    state.form_data_detail = data;
  },

  clearFormDataDetail(state) {
    state.form_data_detail = [];
  },

  setChangeTab(state) {
    state.changed_tab = !state.changed_tab;
  },

  setChangesValueView(state, data) {
    state.changes_value_view = data;
  },
};

const actions = {
  async actionGetSetupFormUi({ dispatch, commit }, data) {
    // dispatch('jStoreNotificationScreen/showLoading', 'Please wait', { root: true });
    let res;
    try {
      res = await jApiFormUi.getSetupFormUi(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setSetupFormUi', res.data);
        // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        // dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      }
    } catch (err) {
      // dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionGetSetupMultiFormUi({ dispatch, commit }, data) {
    let res;
    try {
      res = await jApiFormUi.getSetupMultiFormUi(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        commit('setSetupMultiFormUi', res.data);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  // FORM UI
  async actionGetDetailForm({ commit, dispatch }, params) {
    let res;
    try {
      res = await jApiFormUi.listForm(params);
      commit('setFormDetail', res.data.data);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data;
  },

  async actionSetForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });

    try {
      const res = await jApiFormUi.setForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async createForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiFormUi.setForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      // dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async actionDeleteForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiFormUi.deleteForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', 'Form already used!', { root: true });
      return err.response.data;
    }
  },

  async actionGetFormUiList({ dispatch, commit }, reqData) {
    try {
      const listFormData = await jApiFormUi.listForm(reqData);
      const res = listFormData.data.data ? listFormData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
        res[index].text = lab.name;
      });
      commit('setFormUiList', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetFormUiListAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiFormUi.listForm(reqData);
      const res = resData.data.data ? resData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async findFormUi({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.listForm(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data.data;
  },

  // MULTIPLE FORM UI
  async actionGetDetailMultiForm({ commit, dispatch }, params) {
    let res;
    try {
      res = await jApiFormUi.listMultiForm(params);
      commit('setMultiFormDetail', res.data.data);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionSetMultiForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });

    try {
      const res = await jApiFormUi.setMultiForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response.data;
    }
  },

  async createMultiForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiFormUi.setMultiForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      // dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async actionDeleteMultiForm({ dispatch }, params) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const res = await jApiFormUi.deleteMultiForm(params);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
      return res;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', 'Form already used!', { root: true });
      return err.response.data;
    }
  },

  async actionGetMultiFormUiList({ dispatch, commit }, reqData) {
    try {
      const listFormData = await jApiFormUi.listMultiForm(reqData);
      const res = listFormData.data.data ? listFormData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
        res[index].text = lab.name;
      });
      commit('setMultiFormUiList', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetMultiFormUiListAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiFormUi.listMultiForm(reqData);
      const res = resData.data.data ? resData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async findMultiFormUi({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.listMultiForm(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data.data;
  },

  async actionGetCanvasListAsync({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiFormUi.listCanvas(reqData);
      const res = resData.data.data ? resData.data.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async findCanvas({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.listCanvas(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data.data;
  },

  // FORM DATA
  async actionGetFormDataList({ dispatch, commit }, params) {
    try {
      const listFormData = await jApiFormUi.getListFormData(params);
      const res = listFormData.data ? listFormData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
        res[index].text = lab.name;
      });
      commit('setFormDataList', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetDetailFormData({ commit, dispatch }, params) {
    try {
      const data = { form_data_id: JSON.parse(params.filter).id[0] };
      const res = await jApiFormUi.listFormData(data);
      if (res.data) {
        const formData = [res.data];
        commit('setFormDataDetail', formData);
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async findFormData({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.getListFormData(data);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getFormData({ commit, dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.listFormData(data);
      if (res.data) {
        const formData = [res.data];
        commit('setFormDataDetail', formData);
      }
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getFormDataUi({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.listFormData(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionGetRecordData({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.getRecordData(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        return res;
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionGetRecordDataV2({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.getRecordDataV2(data);
      if (res.error) {
        dispatch('jStoreNotificationScreen/toggleProblem', res.message, { root: true });
      } else {
        return res;
      }
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async actionGetFunctionData({ dispatch }, data) {
    let res;
    try {
      res = await jApiFormUi.getFunctiondata(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res.data;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreFormUi.js